import { render } from "./icon-submenu-show.vue?vue&type=template&id=3740dbf8"
import script from "./icon-submenu-show.vue?vue&type=script&lang=js"
export * from "./icon-submenu-show.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__